<script lang="ts">
	import StoreImage from "@hitit/hub/src/assets/create_store/store.png";
	import { t } from "@hitit/hub/src/stores";

	export let name = "";

</script>

<div class="container">
	<div class="welcome-message">
		<img
			src={StoreImage}
			alt="welcome store registration"
			class="welcome_img" />
		<strong class="welcome-hubby">
			{$t('hub.create_store.welcome_hubby') + name + $t('hub.create_store.sir')}
		</strong>
		<p class="description">
			{$t('hub.create_store.not_have_store')}<br />
			{$t('hub.create_store.you_can_manage')}.
		</p>
	</div>
	<div class="form-box">
		<slot />
	</div>
</div>

<style lang="scss">
	@import "../variables.scss";
	/* mobile first */
	/* 폰트 사이즈 조정 꼭 확인! */

	.container {
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		gap: 21px;
		width: 100%;
		height: 100%;
		flex-grow: 1;
		padding: 30px 20px 80px 20px;

		.welcome-message {
			.welcome_img {
				display: none;
			}

			.welcome-hubby {
				display: block;
				color: white;
				font-weight: $Medium;
				font-size: 1.25rem;
				margin-bottom: 10px;
			}

			.description {
				color: var(--lightGrey);
				font-weight: $UltraLight;
				line-height: 22px;
			}
		}

		.form-box {
			box-sizing: border-box;
			width: 100%;
			padding: 30px 20px;
			background-color: var(--dark-grey);
			border-radius: 10px;
			position: relative;
		}
	}

	@include TabletSize {
		.container {
			.welcome-message {
				.welcome_img {
					display: block;
					width: 60px;
					height: 120px;
					margin-bottom: 20px;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			display: flex;
			flex-direction: row;
			gap: 80px;
			justify-content: center;
			align-items: center;
			padding: 0;
			.welcome-message {
				.welcome-hubby {
					font-size: 1.5rem;
					margin-bottom: 20px;
				}
				.welcome_img {
					display: block;
					width: 82.2px;
					height: 165.8px;
					margin-bottom: 40px;
				}
				.description {
					color: var(--lightGrey);
					font-size: 1.125rem;
					line-height: 30px;
				}
			}
			.form-box {
				max-width: 460px;
			}
		}
	}

</style>
